import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Input } from "antd";
import { useDebouncedCallback } from "use-debounce";
import Sorting from "./Sorting";
import { RootState } from "store/Reducers";
import { handleSetInvoiceFilter } from "../ClientSideStates";

const Search = () => {
  const { filter } = useSelector((state: RootState) => state.invoice);
  let dispatch = useDispatch();
  const debounce = useDebouncedCallback((inputValue) => {
    let value = inputValue?.trim();
    if (value) {
      let newFilter = { ...filter };
      newFilter["Code"] = value;
      dispatch(handleSetInvoiceFilter({ filter: newFilter }));
    } else {
      let newFilter = { ...filter };
      delete newFilter["Code"];
      dispatch(handleSetInvoiceFilter({ filter: newFilter }));
    }
  }, 1000);
  let [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (filter) {
      setSearchValue(filter[`Code`]);
    }
  }, [filter]);

  return (
    <>
      <div className="!flex  items-center">
        <Input
          allowClear
          className="!py-2 !border-0 max-w-sm !w-full"
          placeholder={"Ara..."}
          onChange={(e) => {
            setSearchValue(e.target.value);
            debounce(e.target.value);
          }}
          value={searchValue}
        />
        <Sorting />
      </div>
    </>
  );
};

export default Search;
